import { z } from 'zod';
import {
  creditCardNumberStrategy,
  creditCardExpireDateStrategy,
  creditCardCvcStrategy,
} from '@autopass-web/mochi-utils';

const creditCardScheme = z.object({
  number: z
    .string()
    .min(1, {
      message: '此欄位為必填',
    })
    .refine(creditCardNumberStrategy, {
      message: '格式錯誤',
    }),
  exp: z
    .string()
    .min(1, {
      message: '此欄位為必填',
    })
    .refine(creditCardExpireDateStrategy, {
      message: '格式錯誤',
    }),
  cvc: z
    .string()
    .min(1, {
      message: '此欄位為必填',
    })
    .refine(creditCardCvcStrategy, {
      message: '格式錯誤',
    }),
});

export const scheme = z.object({
  creditCard: creditCardScheme,
});
